// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"543":"3a55eccf","702":"68ed20e6","937":"ce2933e4"}[chunkId] + ".chunk.js";
};